// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2osPv","content":"LayoutSettings_content__2JhuC"};